import { RetailerNetworkLoyaltyMetricsByPeriod, TimeSeriesMetric } from '@occc/graphql';
import { getTrendChange, MetricCardProps, MetricTimePoint } from '@occc/ui-design-system';
import { parseDate } from '@occc-app/lib/date';

export const getRetailConnectLoyaltyPerformanceTimeSeries = (
  series?: TimeSeriesMetric[] | null,
): MetricTimePoint[] => {
  return (
    series?.map(({ date, value }) => ({
      date: parseDate(date),
      value,
    })) ?? []
  );
};

export const getRetailConnectLoyaltyPerformanceMetrics = (
  actual?: RetailerNetworkLoyaltyMetricsByPeriod | null,
  prev?: RetailerNetworkLoyaltyMetricsByPeriod | null,
  periodLabel?: string,
  useInStoreMetrics = false,
): Record<'total' | 'loyalty' | 'sales', MetricCardProps[]> => {
  return {
    total: [
      {
        label: `Total Loyalty Transactions ${periodLabel || ''}`,
        value: actual?.numberOfTransactions ?? 0,
        prevValue: prev?.numberOfTransactions,
        sx: { flexGrow: 2 },
      },
      {
        label: 'Average Spend Per Transaction',
        value: actual?.avgValuePerTransaction ?? 0,
        prevValue: prev?.avgValuePerTransaction,
        valueType: 'cents',
      },
      {
        label: 'Average Transactions Savings',
        value: actual?.avgSavingPerTransaction ?? 0,
        prevValue: prev?.avgSavingPerTransaction,
        valueType: 'cents',
      },
    ],
    loyalty: [
      {
        label: 'Loyalty Units Sold',
        value: (useInStoreMetrics ? actual?.inStoreUnitsSold : actual?.unitsSold) ?? 0,
        prevValue: useInStoreMetrics ? prev?.inStoreUnitsSold : prev?.unitsSold,
      },
      {
        label: 'Average Units Per Basket',
        value: (useInStoreMetrics ? actual?.inStoreAvgUnitsSold : actual?.avgUnitsSold) ?? 0,
        prevValue: useInStoreMetrics ? prev?.inStoreAvgUnitsSold : prev?.avgUnitsSold,
      },
      {
        label: 'Offer Engagement Rate',
        value:
          (useInStoreMetrics ? actual?.inStoreOfferEngagementRate : actual?.offerEngagementRate) ??
          0,
        prevValue: useInStoreMetrics ? prev?.inStoreOfferEngagementRate : prev?.offerEngagementRate,
        valueSuffix: '%',
      },
      {
        label: 'Transaction Trend',
        value: getTrendChange(actual?.numberOfTransactions ?? 0, prev?.numberOfTransactions ?? 0),
        valueType: 'percentage',
      },
    ],
    sales: [
      {
        label: 'Total Instore Sales',
        value: actual?.totalUnitsSales ?? 0,
        prevValue: prev?.totalUnitsSales,
        valueType: 'cents',
      },
      {
        label: 'Average Per-Store Sales',
        value: actual?.avgUnitsSalesPerStore ?? 0,
        prevValue: prev?.avgUnitsSalesPerStore,
        valueType: 'cents',
      },
      {
        label: 'Total Fuel Sales',
        value: actual?.totalFuelSales ?? 0,
        prevValue: prev?.totalFuelSales,
        valueType: 'cents',
      },
      {
        label: 'Avg Fuel Gallons per Transaction',
        value: actual?.avgFuelSalesPerTransaction ?? 0,
        prevValue: prev?.avgFuelSalesPerTransaction,
      },
    ],
  };
};
